export interface CommunityFeatureItem {
  id: string;
  label: string;
  icon: string;
  color: string;
  desc: string;
  enabled: boolean;
}

export const defaultCommunityFeatures: CommunityFeatureItem[] = [
  {
    id: 'chat',
    label: 'Chat',
    icon: 'ri-chat-3-line',
    color: 'bg-emerald-500',
    desc: 'Chat en vivo entre oyentes y locutores durante las transmisiones. Los mensajes aparecen en tiempo real en la cabina.',
    enabled: true,
  },
  {
    id: 'saludos',
    label: 'Saludos',
    icon: 'ri-user-heart-line',
    color: 'bg-rose-500',
    desc: 'Los oyentes pueden enviar saludos y dedicatorias al aire. El locutor los recibe en la cabina y decide cuáles leer.',
    enabled: true,
  },
  {
    id: 'canciones',
    label: 'Canciones',
    icon: 'ri-music-2-line',
    color: 'bg-violet-500',
    desc: 'Permite que los oyentes pidan canciones durante la programación. Las solicitudes llegan a la cola de la cabina.',
    enabled: true,
  },
  {
    id: 'comentarios',
    label: 'Comentarios',
    icon: 'ri-message-2-line',
    color: 'bg-amber-500',
    desc: 'Los seguidores pueden comentar en publicaciones, fotos y videos del perfil de la radio. Fomenta la interacción.',
    enabled: true,
  },
  {
    id: 'eventos',
    label: 'Eventos',
    icon: 'ri-calendar-event-line',
    color: 'bg-cyan-500',
    desc: 'Gestión de eventos presenciales y virtuales. Los oyentes pueden confirmar asistencia y recibir recordatorios.',
    enabled: false,
  },
  {
    id: 'concursos',
    label: 'Concursos',
    icon: 'ri-trophy-line',
    color: 'bg-orange-500',
    desc: 'Creación y gestión de concursos y sorteos para la audiencia. Participación con un clic desde el perfil de la radio.',
    enabled: false,
  },
  {
    id: 'club-vip',
    label: 'Club VIP',
    icon: 'ri-vip-diamond-line',
    color: 'bg-indigo-500',
    desc: 'Programa de fidelización con beneficios exclusivos para oyentes frecuentes. Insignias, contenido anticipado y más.',
    enabled: false,
  },
];